/** Accept only local destinations, and never return back into the sign-in page. */
export function safeSignInReturnPath(value: unknown): string {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//") ||
    /[\\\u0000-\u001f\u007f]/.test(value)) return "";
  const url = new URL(value, "https://lato.invalid");
  if (url.origin !== "https://lato.invalid" || /^\/signin\/?$/.test(url.pathname)) return "";
  return `${url.pathname}${url.search}${url.hash}`;
}
